<template>
  <div id="main-wrapper">
    <router-view class="wrapper"></router-view>
    <!-- <app-loader></app-loader> -->
    <app-contact-modal v-if="getContactModal()"></app-contact-modal>
    <app-protocol></app-protocol>
  </div>
</template>

<script>
export default{
  mounted(){
    // var userLang = navigator.language || navigator.userLanguage;
    // if(userLang.includes('en')){
    //   this.updateLanguage('EN')
    // }else{
    //   this.udpateLanguage('ES')
    // }
  }
}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Open+Sans&display=swap');
  @import './assets/stylesheets/application.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue